import type { FC } from 'react'

import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import type { Recipe } from '@segment/api/types/common'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

const recipesLink = {
  text: `See all recipes`,
  href: `/recipes`,
}

interface RelatedRecipesProps {
  recipes: Recipe[]
}

const RelatedRecipes: FC<RelatedRecipesProps> = ({ recipes }) => {
  const pageConfig = usePageConfig()
  return (
    <CardsSection title="Related recipes">
      <CardsGroup>
        {recipes.map(({ authors, title, description, slug, roles, experienceLevel, industries }) => (
          <Card
            key={title}
            authors={authors}
            title={title}
            description={description}
            roles={roles}
            experienceLevel={experienceLevel}
            industries={industries}
            slug={slug}
          />
        ))}
      </CardsGroup>
      <AllRecipesWrapper>
        <ButtonText tag="a" href={getAbsoluteUrl(recipesLink.href, pageConfig)} iconEnd={ChevronRightIcon}>
          {recipesLink.text}
        </ButtonText>
      </AllRecipesWrapper>
    </CardsSection>
  )
}

const AllRecipesWrapper = styled.div`
  display: flex;
  padding-top: 56px;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 80px;
  }
`
export default RelatedRecipes
